const userDefaultValues = {
    views:{
        assetManagement:{
            group:{
                table:{
                    labels:[],
                    fields: []
                }
            },
            container:{
                table:{
                    labels: [],
                    fields: []
                }
            },
            devices:{
                table:{
                    labels:[],
                    fields: []
                }
            }
        }
    }
}
export default userDefaultValues